export default __webpack_public_path__ + "static/media/07.58.00ddf4b0.jpg";